// extracted by mini-css-extract-plugin
module.exports = {"flex":"prevNext_flex__2XK20","imageWrapper":"prevNext_imageWrapper__VlVEn","prevButton":"prevNext_prevButton__1FDyM","nextButton":"prevNext_nextButton__25fyG"};